// @flow
import * as React from 'react';

import {
  selectIsAuthenticatedUser,
  selectTaxesDisplaySetting,
} from '@gandi/authentication';
import { selectPricingInfos } from '@gandi/billing';
import { selectHasVat } from '@gandi/redux-places';
import { setProps } from '@gandi/tracking';
import { localeSelector as selectLocale } from '@gandi/translate';

import { useAppSelector } from 'src/hooks/useAppSelector';

import { selectCurrentBU } from '../modules/organization/selectors';

import type { FullState } from '../types/index';

export const useTrackingProps = () => {
  // $FlowFixMe[incompatible-call]
  const { grid, country, currency } = useAppSelector(selectPricingInfos);
  const authenticated = useAppSelector(selectIsAuthenticatedUser);
  const locale = useAppSelector(selectLocale);

  const taxesIncluded = useAppSelector(selectTaxesDisplaySetting);
  const hasTaxes = useAppSelector((state: FullState) =>
    selectHasVat(state, country),
  );
  const taxesDisplay = taxesIncluded ? 'true' : 'false';
  const currentBU = useAppSelector(selectCurrentBU);

  React.useEffect(() => {
    setProps(
      {
        country,
        currency,
        grid,
        lang: locale,
        loggedin: authenticated,
        taxes: hasTaxes || authenticated ? taxesDisplay : 'N/A',
      },
      {
        persistent: true,
        events: ['page.*'],
      },
    );
  }, [country, currency, grid, locale, authenticated, hasTaxes, taxesDisplay]);

  React.useEffect(
    () =>
      setProps(
        {
          bu: currentBU,
        },
        {
          persistent: true,
          events: ['*'],
        },
      ),
    [currentBU],
  );
};
